module.exports = __webpack_public_path__ + "static/media/info.89a4ff78.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info.svg
// module id = 861
// module chunks = 0